import { createFileRoute } from '@tanstack/react-router';
import { AdminRoleAuditPage } from '@pages/admin';

export const Route = createFileRoute('/$locale/_authenticated/admin/settings/business/roles/audit')(
  {
    component: AdminRoleAuditSettingsRoute,
  }
);

function AdminRoleAuditSettingsRoute() {
  return <AdminRoleAuditPage />;
}
